import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import GruposDeContacto from './GruposDeContacto';
import DetalleInformacion from './DetalleInformacion';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function ScrollDetailsPanel({reload, idRegistro, informacionGeneral, permisos, toggleDetalleEncuestaSaludModal, toggleDetalleVacunaModal, togglDatosContactosModal}) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
        >
          <Tab label="Datos Generales" {...a11yProps(0)} />
          <Tab label="Grupos de contacto" {...a11yProps(1)} disabled={!permisos?.PuedeVerGrupoContacto}/>
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        <DetalleInformacion idRegistro={idRegistro} permisos={permisos} informacionGeneral={informacionGeneral} toggleDetalleEncuestaSaludModal={toggleDetalleEncuestaSaludModal} toggleDetalleVacunaModal={toggleDetalleVacunaModal} togglDatosContactosModal={togglDatosContactosModal}/>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <GruposDeContacto reload={reload} idRegistro={idRegistro} informacionGeneral={informacionGeneral}/>
      </TabPanel>
    </div>
  );
}
